if (!customElements.get('quick-view-modal')) {
  customElements.define(
    'quick-view-modal',
    class QuickViewModal extends DrawerComponent {
      constructor() {
        super();

        this._classes = {
          loaded: 'quick-view-loaded',
        };
        this.drawerBody = this.querySelector(this.selector);
      }

      get selector() {
        return '.quick-view__content';
      }

      get sourceSelector() {
        return '#MainProduct-quick-view__content';
      }

      get requiresBodyAppended() {
        return !(Shopify.designMode && this.closest('.section-group-overlay-quick-view'));
      }

      shouleBeShow() {
        const sectionId = this.getProductQuickViewSectionId();
        return typeof sectionId === 'string';
      }

      prepareToShow() {
        super.prepareToShow();
        this.quickview();
      }

      handleAfterShow() {
        super.handleAfterShow();
        document.dispatchEvent(
          new CustomEvent('quick-view:open', {
            detail: { productUrl: this.dataset.productUrl },
          })
        );
      }

      handleAfterHide() {
        super.handleAfterHide();
        const drawerContent = this.querySelector(this.selector);
        drawerContent.innerHTML = '';
        this.classList.remove(this._classes.loaded);
      }

      getProductQuickViewSectionId() {
        let sectionId = FoxTheme.QuickViewSectionId || false;

        if (!sectionId) {
          // Get section id from overlay groups.
          const productQuickView = document.querySelector('.section-group-overlay-quick-view');
          if (productQuickView) {
            sectionId = FoxTheme.utils.getSectionId(productQuickView);
          }

          // Cache for better performance.
          FoxTheme.QuickViewSectionId = sectionId;
        }

        return sectionId;
      }

      quickview() {
        const drawerContent = this.querySelector(this.selector);
        const sectionId = this.getProductQuickViewSectionId();
        const sectionUrl = `${this.dataset.productUrl.split('?')[0]}?section_id=${sectionId}`;
        fetch(sectionUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const productElement = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(this.sourceSelector);

            this.setInnerHTML(drawerContent, productElement.content.cloneNode(true));
            FoxTheme.a11y.trapFocus(this, this.focusElement);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            setTimeout(() => {
              this.classList.add(this._classes.loaded);


                document.addEventListener('variant:changed', function(event) {
                  // Assuming you have these variables from your JavaScript
                  let formOption = event.detail.variant.option2 ? event.detail.variant.option2 : '';

                  let productTitle = event.detail.variant.name.split(" - ")[0];
                  const addToCart = document.getElementById("in-page-add-to-cart");
                  
                  if (formOption == "Ground" || formOption == "Whole") {
                    addToCart.innerHTML = `Add <strong>${formOption}</strong> ${productTitle} to Cart`;
                  } else {
                    addToCart.innerHTML = `Add ${productTitle} to Cart`;
                  }
                });


                  const weightElements = document.querySelectorAll('.variant-weight');

                  function updateWeightDisplay(variantId) {
                    // Hide all weight elements by adding the 'hidden' class
                    weightElements.forEach(element => {
                      element.classList.add('hidden');
                    });
                    
                    // Show the weight for the selected variant by removing the 'hidden' class
                    const selectedWeightElement = document.getElementById(`variant-weight-${variantId}`);
                    if (selectedWeightElement) {
                      selectedWeightElement.classList.remove('hidden');
                    }
                  }

                  // Listen for the variant change event
                  document.addEventListener('variant:changed', function(event) {
                    const selectedVariantId = event.detail.variant.id;

                    
                    updateWeightDisplay(selectedVariantId);
                    window.quickvarint = selectedVariantId;
                    console.log("selectedVariantId",selectedVariantId,quickvarint)
                  });



            }, 300);

            document.dispatchEvent(
              new CustomEvent('quick-view:loaded', {
                detail: { productUrl: this.dataset.productUrl },
              })
            );
          })
          .catch((e) => {
            console.error(e);
          });
      }

      setInnerHTML(element, innerHTML) {
        element.innerHTML = '';
        element.appendChild(innerHTML);
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      disconnectedCallback() {
        super.disconnectedCallback();
        this.handleAfterHide();
      }
    }
  );
}
